import http from '@/plugins/http'

export default class Timezones {
  static all() {
    return http.get('/timezones')
  }
}
